var map = {
	"./accessory/accessory1.png": "dqFi",
	"./accessory/accessory2.png": "Jark",
	"./accessory/accessory3.png": "5KhT",
	"./accessory/accessory4.png": "/kBW",
	"./accessory/accessory5.png": "xVl4",
	"./accessory/accessory6.png": "lkfn",
	"./accessory/accessory7.png": "yAB6",
	"./accessory/accessory8.png": "SGYm",
	"./background/background1.png": "iVBB",
	"./background/background2.png": "yxcX",
	"./background/background3.png": "My1n",
	"./background/background4.png": "A8cz",
	"./bg.png": "yRcn",
	"./button/accessory/accessory1.png": "Ivbd",
	"./button/accessory/accessory2.png": "zt/d",
	"./button/accessory/accessory3.png": "LVeo",
	"./button/accessory/accessory4.png": "Lr6l",
	"./button/accessory/accessory5.png": "GKul",
	"./button/accessory/accessory6.png": "Lno8",
	"./button/accessory/accessory7.png": "wMS4",
	"./button/accessory/accessory8.png": "uHLW",
	"./button/accessory/accessory_cover.png": "GDsN",
	"./button/background/background1.png": "bc2/",
	"./button/background/background2.png": "0lyT",
	"./button/background/background3.png": "KsDq",
	"./button/background/background4.png": "f0xL",
	"./button/background/background_cover.png": "RJXM",
	"./button/cloth/cloth1.png": "6/oq",
	"./button/cloth/cloth2.png": "lR10",
	"./button/cloth/cloth3.png": "EOlO",
	"./button/cloth/cloth4.png": "rwOs",
	"./button/cloth/cloth5.png": "v/ZS",
	"./button/cloth/cloth6.png": "BSQK",
	"./button/cloth/cloth7.png": "12Gg",
	"./button/cloth/cloth8.png": "EvzF",
	"./button/cloth/cloth_cover.png": "zz/7",
	"./button/face/face1.png": "oBRq",
	"./button/face/face2.png": "ZkQ4",
	"./button/face/face3.png": "NuTl",
	"./button/face/face4.png": "B4ca",
	"./button/face/face5.png": "PqkN",
	"./button/face/face6.png": "FSSh",
	"./button/face/face7.png": "kUjc",
	"./button/face/face8.png": "r9lc",
	"./button/face/face_cover.png": "VPbv",
	"./button/hair/hair1.png": "zTXS",
	"./button/hair/hair2.png": "L8zA",
	"./button/hair/hair3.png": "sj2U",
	"./button/hair/hair4.png": "Azsn",
	"./button/hair/hair5.png": "oxNP",
	"./button/hair/hair6.png": "WDkw",
	"./button/hair/hair7.png": "YOva",
	"./button/hair/hair8.png": "sZ8V",
	"./button/hair/hair_cover.png": "W0EQ",
	"./cloth/cloth1.png": "n9CA",
	"./cloth/cloth2.png": "nzje",
	"./cloth/cloth3.png": "scec",
	"./cloth/cloth4.png": "O3AY",
	"./cloth/cloth5.png": "6sfm",
	"./cloth/cloth6.png": "GQhE",
	"./cloth/cloth7.png": "kYxa",
	"./cloth/cloth8.png": "sKLQ",
	"./download.png": "0SEy",
	"./error.png": "FF+y",
	"./face/face1.png": "i3LS",
	"./face/face2.png": "MFTJ",
	"./face/face3.png": "1BKx",
	"./face/face4.png": "f/QW",
	"./face/face5.png": "Zu6k",
	"./face/face6.png": "O9X0",
	"./face/face7.png": "MMT8",
	"./face/face8.png": "jpkJ",
	"./fb-share.png": "tH7s",
	"./hair/hair1.png": "6HLG",
	"./hair/hair2.png": "KeR0",
	"./hair/hair3.png": "wxyf",
	"./hair/hair4.png": "V9Lc",
	"./hair/hair5.png": "JBHn",
	"./hair/hair6.png": "Ukbx",
	"./hair/hair7.png": "MIcU",
	"./hair/hair8.png": "vkTp",
	"./logo.png": "iQH9",
	"./main/people.png": "q3sd",
	"./main/shadow.png": "2y5t",
	"./play-again.png": "9Vae",
	"./slogan/slogan1.png": "ARWl",
	"./slogan/slogan1_black.png": "FejH",
	"./slogan/slogan2.png": "eV28",
	"./slogan/slogan2_black.png": "5FAS",
	"./slogan/slogan3.png": "GTQ3",
	"./slogan/slogan3_black.png": "m7jc",
	"./thai_logo.png": "KNq8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tsha";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.png$
// module id = tsha
// module chunks = 0